import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";

/**
 * @desc Schema for Orders form.
 */
const schema = yup.object({
  password: yup.string().required("Required"),
});

/**
 * @desc Hook for validating login form.
 */
export const useLoginForm = (defaultValues = {}) => {
  return useForm({
    resolver: yupResolver(schema),
    mode: "all",
    defaultValues,
  });
};
